import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';

class AddRequest extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			user: {
				ID: null,
				FACILITYID: null
			},
			renderKey: 0
		}
	}	
		
	onChange(accessor, value) {
		var user = this.copyObject(this.state.user);
		if (Array.isArray(accessor)) {
			for (var i = 0; i < accessor.length; i++) {
				this.setByAccessor(user, accessor[i], value[i]);
			}
		} else {
			this.setByAccessor(user, accessor, value);
		}
		this.mergeState({ user: user });
	}
	
	validateUser(event, columns, data) {
		return this.validate(columns, data);
	}

	onSubmit(event) {
		var facilityId = this.isNumeric(this.state.user.FACILITYID) ? +this.state.user.FACILITYID : 0;
		
		if (facilityId === 33) {
			this.showAlert('Not Implemented', 'X-Ray Crystallography not implemented.');
		} else if (facilityId === 34) {
			this.props.navigate('/FAS/Microrequests/new/' + this.state.user.ID);
		} else {
			this.showAlert('Unknown Facility', 'Unknown facility id ' + this.state.user.FACILITYID);
		}
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
						  Create Request
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={userColumns} data={this.state.user}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							validate={(event, columns, data) => this.validateUser(event, columns, data)}
							onSubmit={(event) => this.onSubmit(event)}>
							<Form.Group as={Row}>
							  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
								<Button id="create" variant="warning" type="submit" className="float-end">Create</Button>
							  </Col>
							</Form.Group>							
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const userColumns = [
	{ Header: 'Select User', accessor: ['ID','FACILITYID'], type: 'select', row: 0, col: 0, required: true,
		options: { value: ['ID','FACILITYID'], label: 'NAME', entity: 'FAS.USER_SELECT_VW', order: 'NAME_ORDER' }}
];

export default withRouter(AddRequest);
